import { memo } from 'react';

import { Pause } from '@air/next-icons';

export const FileStatusIconPaused = memo(() => {
  return (
    <div aria-hidden className="mr-3 flex size-10 items-center justify-center rounded-full bg-amber-4">
      <Pause className="size-6 fill-amber-11" />
    </div>
  );
});

FileStatusIconPaused.displayName = 'FileStatusIconPaused';
